<template>
  <div class="bt-contactus" :style="'min-height:' + height + 'px'">
    <div class="bt-main-container">
      <div class="bt-title">加入我们<span class="bt-subtitle">JOIN US</span></div>
      <p class="bt-contactus-intro">云南栢田医疗科技有限公司 — 深耕医疗服务 27年，全国医疗三方维保头部企业！拥有7省控股子公司，自研医疗设备全生命周期管理系统，SPD+维保双轮驱动。2026年全面启动全国战略扩张，诚邀西安、甘肃、青海、云南、四川、贵州、湖南、湖北等区域销售精英加盟，共创医疗工程人员高层次生活新未来！</p>
      <div class="bt-contactus-jobs">
        <div class="bt-job" v-for="(item, index) in jobList" :key="index">
          <div class="bt-job-title">
            <svg class="bt-job-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="8" r="3.5"></circle>
              <path d="M2.5 19c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5"></path>
              <circle cx="17" cy="9" r="2.8"></circle>
              <path d="M16 12.9c3.1 0.5 5.5 3 5.5 6.1"></path>
            </svg>
            <span>{{ item.title }}</span>
          </div>
          <ul class="bt-job-info">
            <li v-for="(row, i) in item.info" :key="i">
              <span class="bt-job-label">{{ row.label }}：</span><span class="bt-job-value">{{ row.value }}</span>
            </li>
          </ul>
        </div>
        <div class="bt-job-more-wrap" @click="jobMoreClick">
          <span class="bt-job-more">更多职位信息<i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
      <div class="bt-contactus-main">
        <el-image
          class="bt-contactus-image"
          :src="require('@/assets/images/baitian-erweima.png')"
          fit="fill"></el-image>
        <ul class="bt-contactus-list">
          <li>
            <i class="el-icon-phone-outline"></i>
            <span>087164101608</span>
          </li>
          <li>
            <i class="el-icon-location-outline"></i>
            <span>云南省五华区融城园城医药健康科技园17楼</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: window.innerHeight - 360,
      jobList: [
        {
          title: 'SPD运营总监',
          info: [
            { label: '所属部门', value: 'SPD 运营中心' },
            { label: '工作地点', value: '全国各个项目（驻地）' },
            { label: '核心职责', value: 'SPD项目运营管理、流程优化、项目交付、团队管理' },
          ],
        },
        {
          title: '全国各区域营销经理',
          info: [
            { label: '所属部门', value: '销售中心' },
            { label: '工作地点', value: '全国各省份（西安、甘肃、青海、云南、四川、贵州、湖南等）' },
            { label: '招聘模式', value: '驻地招聘' },
            { label: '核心职责', value: '区域销售目标达成、客户开发、渠道维护' },
          ],
        },
      ],
    }
  },
  mounted() {
    
  },
  methods: {
    jobMoreClick() {
      window.open('https://www.zhipin.com/gongsi/job/552da83ef57f4a7e1Hxy29S5FQ~~.html?ka=company-jobs')
    }
    
  }
}
</script>

<style scoped lang="scss">
  .bt-contactus {
    background-image: url('../../assets/images/contactus-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    padding-bottom: 60px;
  }

  .bt-contactus-intro {
    margin: 20px 0 45px;
    font-size: 16px;
    line-height: 2;
    color: #555;
    text-indent: 2em;
    text-align: justify;
  }

  .bt-contactus-jobs {
    display: flex;
    align-items: flex-start;
  }

  .bt-job {
    margin-right: 8%;
    width: 26%;
    &:nth-child(2) {
      margin-right: 0;
      width: 40%;
    }
  }

  .bt-job-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: bold;
    color: $themes_color;
    .bt-job-icon {
      margin-right: 8px;
      width: 24px;
      height: 24px;
    }
  }

  .bt-job-info {
    li {
      margin-top: 10px;
      font-size: 14px;
      line-height: 1.8;
      color: #333;
    }
  }

  .bt-job-more-wrap {
    flex: 1;
    display: flex;
    justify-content: center;
    align-self: center;
    cursor: pointer;
  }

  .bt-job-more {
    padding: 11px 38px;
    border: 1px solid $themes_color;
    border-radius: 24px;
    font-size: 16px;
    color: $themes_color;
    transition: opacity 0.3s;
    i {
      margin-left: 6px;
      font-size: 14px;
    }
    &:hover {
      opacity: 0.8;
    }
  }

  .bt-contactus-main {
    display: flex;
    align-items: center;
    margin-top: 60px;
  }

  .bt-contactus-image {
    flex: 0 0 auto;
    margin-right: 30px;
    width: 90px;
    height: 90px;
  }

  .bt-contactus-list {
    li {
      display: flex;
      align-items: center;
      margin-top: 14px;
      font-size: 14px;
      color: #666;
      &:first-child {
        margin-top: 0;
      }
      i {
        margin-right: 10px;
        font-size: 20px;
        color: #999;
      }
      span {
        padding: 4px 8px;
        background-color: rgba(0, 0, 0, 0.06);
      }
    }
  }

@media Screen and (max-width: $screen_width) {
  .bt-contactus-intro {
    margin-bottom: 30px;
    font-size: 14px;
  }
  .bt-contactus-jobs {
    display: block;
  }
  .bt-job,
  .bt-job:nth-child(2) {
    margin-right: 0;
    margin-bottom: 30px;
    width: 100%;
  }
  .bt-job-more-wrap {
    display: block;
    text-align: center;
  }
  .bt-contactus-main {
    margin-top: 40px;
  }
}


</style>
